import itemTemplate from '../../pug/news-list-item.pug';
import lozad from 'lozad';
import LazyImages from './lazy-images';

let load   = true;
const init = (instance) => {

    let $list   = document.querySelector('.list-news');
    let nextUrl = $list.getAttribute('data-next-page');

    window.addEventListener('scroll', (event) => {

        if (window.scrollY > (document.querySelector('body').offsetHeight - window.innerHeight - document.querySelector('.footer').clientHeight)) {
            if (load && nextUrl) {
                load = false;
                $list.classList.add('loading');

                fetch(nextUrl)
                    .then(response => response.json())
                    .then(json => {
                        if (json.success) {
                            json.data.forEach(item => {
                                let $wrapper = document.createElement('div');
                                $wrapper.innerHTML += itemTemplate({
                                    item
                                });

                                $list.appendChild($wrapper.firstChild);

                                new LazyImages($list.querySelectorAll('img.vgtrk-lazy'));
                            });

                            nextUrl = json.pagination.next;
                            $list.classList.remove('loading');

                            if (nextUrl) {
                                load = true;
                            }
                        }
                    });
            }
        }
    })
};

export default class ListNews {
    constructor($selector) {
        return $selector ? init(this) : {};
    }
}
